import { encode, decode } from '@msgpack/msgpack';

const PATH = location.protocol === 'https:' ? 'wss://' + location.host + '/ws/' : 'ws://' + location.host + '/ws/';

export default class Connection {
    public serializedClient?: Uint8Array;
    public clientId?: string;
    private ws: WebSocket;
    constructor(
        authToken: Promise<string>,
        cb: (serializedSubstate: Uint8Array) => void,
    ) {
        this.ws = new WebSocket(PATH);
        this.ws.binaryType = 'arraybuffer';

        this.ws.onopen = () => {
            authToken.then((token) => {
                this.ws.send(encode({
                    Token: token,
                }));
            });
        };

        this.ws.onmessage = (event) => {
            const data: any = decode(event.data);
            if (data.InitClient) {
                this.serializedClient = new Uint8Array(data.InitClient[0]);
                this.clientId = data.InitClient[1];
            } else if (data.SubState) {
                cb(new Uint8Array(data.SubState));
            } else {
                console.error('unrecognized message:', data);
            }
        };
        this.ws.onclose = (event) => {
            alert('You have been disconnected - please refresh!');
        };
    }

    public sendEvent(ev: Uint8Array) {
        if (this.ws.readyState !== WebSocket.OPEN) {
            console.error('tried to send event but ws isn\'t open');
            return;
        }
        this.ws.send(encode({
            Event: ev,
        }));
    }

    public close() {
        this.ws.close();
    }
}
